import React from 'react';
import PropTypes from 'prop-types';
import './CategorySwitcher.css';

const GENDERS = [
  { value: 'nina', label: 'NIÑA' },
  { value: 'nino', label: 'VARÓN' },
];

export default function GenderSwitcher({ selectedGender, onChange }) {
  return (
    <section className="gender-switcher">
      <div className="category-switcher__tabs">
        {GENDERS.map(({ value, label }) => (
          <button
            key={value}
            onClick={() => onChange(selectedGender === value ? null : value)}
            className={`category-switcher__tab ${selectedGender === value ? 'is-active' : ''}`}
          >
            {label}
          </button>
        ))}
      </div>
    </section>
  );
}

GenderSwitcher.propTypes = {
  selectedGender: PropTypes.oneOf(['nino', 'nina', null]),
  onChange: PropTypes.func.isRequired,
};

GenderSwitcher.defaultProps = {
  selectedGender: null,
};
